import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ChevronRight from 'assets/images/home/chevron-right.svg';

const { Link, Text } = Typography;
type NewsCardProps = {
  url?: string;
};
const KnowMoreLink = styled(Link)`
  display: flex;
  // margin-top: 8px;
`;

const KnowMoreLinkText = styled(Text)`
  font-weight: 700;
  color: var(--grey-800);
  white-space: nowrap;
`;

const KnowMoreLinkImage = styled.img`
  margin-left: 13px;
  width: 12px;
  height: 12px;
  margin-top: 5px;
`;

const NewsCard = ({ url }: NewsCardProps) => {
  const { t } = useTranslation();
  return (
    <KnowMoreLink href={url ? url : '#'} target="_blank">
      <KnowMoreLinkText>{t('home.reminderMsgButton')}</KnowMoreLinkText>
      <KnowMoreLinkImage src={ChevronRight} alt="know-more-arrow" />
    </KnowMoreLink>
  );
};

export default NewsCard;
